import(/* webpackMode: "eager" */ "/usr/src/app/front/apps/web/app/global-error.tsx");
